function initProductPage(section) {
  if (!section || !section.classList.contains("product-section")) {
    return;
  }

  const initMainSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-list");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
    const navPrev = sliderEl.querySelector(".swiper-button-prev");
    const navNext = sliderEl.querySelector(".swiper-button-next");
    const mediaBox = sliderEl.closest(".product__media");
    const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");

    const isFilteredGallery = mediaBox?.dataset.sejiArtTypeFilter === "true";
    const isLoop = !isFilteredGallery && sliderEl.querySelectorAll(".swiper-slide").length > 2;

    const initSwiper = () => {
      if (sliderEl.swiper && !sliderEl.swiper.destroyed) return;
      new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: isLoop,
        rewind: isFilteredGallery,
        direction: "horizontal",
        speed: 800,
        allowTouchMove: true,
        watchSlidesProgress: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        breakpoints: {
          990: {
            slidesPerView: desktopType === "slider" ? "auto" : 1,
            allowTouchMove: !hasDesktopZoom,
          },
        },
        thumbs: {
          swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
        },
        on: {
          slideChange: function () {
            //window.pauseAllMedia();
            window.pauseAllModels();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    const destroySwiper = () => {
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy();
      }
      sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
        wrapper.removeAttribute("style");
      });
      sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.removeAttribute("style");
      });
    };

    const hasDesktopSwiper =
      desktopType === "slider" || desktopType == "slider_previews";
    const hasMobileSwiper =
      mobileType === "slider" || mobileType == "slider_previews";

    if (hasDesktopSwiper && hasMobileSwiper) {
      initSwiper();
    } else {
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth >= 990 && hasDesktopSwiper) {
            initSwiper();
            return;
          }

          if (window.innerWidth < 990 && hasMobileSwiper) {
            initSwiper();
            return;
          }

          destroySwiper();
        });
      });

      resizeObserver.observe(section);
    }
  };

  const initSubSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-sublist");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopSwiper = desktopType === "slider_previews";
    const hasMobileSwiper = mobileType === "slider_previews";

    const isLoop = sliderEl.closest(".product__media")?.dataset.sejiArtTypeFilter !== "true" &&
      sliderEl.querySelectorAll(".swiper-slide").length > 3;

    const initSwiper = () => {
      const thumbSlider = new Swiper(sliderEl, {
        spaceBetween: 8,
        slidesPerView: 4,
        loop: isLoop,
        direction: "horizontal",
        allowTouchMove: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoHeight: false,
        slideToClickedSlide: true,
        on: {
          touchEnd: function (swiper) {
            let range = 5;
            let diff = (swiper.touches.diff = swiper.isHorizontal()
              ? swiper.touches.currentX - swiper.touches.startX
              : swiper.touches.currentY - swiper.touches.startY);
            if (diff < range || diff > -range) swiper.allowClick = true;
          },
        },
        breakpoints: {
          576: {
            slidesPerView: 6,
          },
          990: {
            slidesPerView: "auto",
            direction: "vertical",
          },
        },
      });

      return thumbSlider;
    };

    if (hasDesktopSwiper || hasMobileSwiper) {
      initSwiper();

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (sliderEl.swiper) {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("vertical", true);
            }

            if (
              window.innerWidth >= 990 &&
              desktopType === "stacked_previews"
            ) {
              sliderEl.swiper.disable();
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("horizontal", true);
            }
          }
        });
      });

      resizeObserver.observe(section);
    }
  };

  const initZoomSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sectionBox = section.querySelector('[id^="MainProduct-"]');
    const sectionId = sectionBox?.dataset?.section;
    const sliderEl = document.querySelector(
      `[data-section-id='${sectionId}'].js-popup-slider`
    );
    if (!sliderEl) return;

    const buttonPrev = sliderEl.querySelector(".swiper-button-prev");
    const buttonNext = sliderEl.querySelector(".swiper-button-next");

    const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 3;

    const onMainSliderToggleClick = (event) => {
      if (!sliderEl.swiper) return;
      const zoomToggle = event.target.closest(".product__media-toggle");
      if (!zoomToggle) return;
      const mediaId = zoomToggle.dataset?.mediaId;
      if (!mediaId) return;
      sliderEl
        .querySelectorAll(".product-media-modal__item.swiper-slide")
        .forEach((slide, index) => {
          const zoomImageEl = slide.querySelector(
            `[data-media-id="${mediaId}"]`
          );
          if (zoomImageEl) {
            const findIndex = sliderEl.swiper.slides.findIndex(
              (slideEl) => slideEl.dataset?.mediaId === mediaId
            );
            const fallbackIndex = Number(
              slide.dataset?.swiperSlideIndex || index
            );
            const slideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
            sliderEl.swiper.slideTo(slideIndex, 0);
            sliderEl.swiper.update();
          }
        });
    };

    new Swiper(sliderEl, {
      slidesPerView: 1,
      speed: 800,
      loop: isLoop,
      zoom: {
        maxRatio: 2,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      on: {
        afterInit: function () {
          section
            .querySelectorAll(".product__media-list .product__media-toggle")
            .forEach((elem) => {
              elem.addEventListener("click", onMainSliderToggleClick);
            });
        },
        slideChange: function () {
          //window.pauseAllMedia();
          window.pauseAllModels();
          this.params.noSwiping = false;
          sliderEl.classList.remove("zoom");
        },
        touchMove: function () {
          sliderEl.classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          const activeIndex = isLoop ? this.realIndex : this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          const posterBtn3D = this.slides[activeIndex]?.querySelector(
            ".shopify-model-viewer-ui__button--poster"
          );
          if (model3D && posterBtn3D) {
            posterBtn3D.removeAttribute("hidden");
          }
        },
        touchStart: function () {
          const activeIndex = isLoop ? this.realIndex : this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          if (model3D) {
            if (
              !model3D.classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  };

  const initArtTypeMediaFilter = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaBox = section.querySelector(".product__media");
    const mediaScope = section.querySelector(".product__media-wrapper") || mediaBox;
    const variantPicker = section.querySelector("variant-radios, variant-selects");
    const variantsScript = variantPicker?.querySelector("[data-all-variants-no-high]");
    if (!mediaBox || !variantPicker || !variantsScript) return;

    mediaBox.sejiMediaFilterCleanup?.();

    const productHandle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || "";
    const artTypeFilterProductHandles = new Set([
      "amalfi-azure-skies-coastal-drive-art",
      "amalfi-golden-hour-coastal-drive-art",
      "onomichi-hillside-town-japan-art",
      "amsterdam-canal-bookstore-twilight-art",
      "bruges-autumn-bookstore-art",
      "amsterdam-snowy-bookstore-art",
      "paris-rainy-bookstore-evening-art",
      "notting-hill-wisteria-bookstore-art",
      "edinburgh-lamp-post-bookstore-rain-art",
      "montmartre-archway-bookstore-evening-art",
      "paris-umbrella-bookstore-night-art",
      "bruges-snowy-green-door-bookstore-art",
      "mong-kok-sun-shower-market-street-art",
      "kowloon-lantern-rain-alley-art",
      "sheung-wan-lantern-morning-alley-art",
      "sham-shui-po-rainy-market-street-art",
      "mong-kok-red-coat-rain-alley-art",
      "yanaka-tokyo-morning-alley-art",
      "shinjuku-neon-rain-street-art",
      "nakano-tokyo-flower-shopping-street-art",
      "kanda-tokyo-morning-alley-art",
      "kichijoji-tokyo-sunny-shopping-street-art",
      "jiyugaoka-tokyo-sunlit-signage-street-art",
      "nakameguro-tokyo-afternoon-shopping-street-art",
      "mong-kok-night-market-rain-art",
      "yau-ma-tei-sunset-market-street-art",
      "sheung-wan-hong-kong-hillside-stairs-art",
      "wan-chai-hong-kong-rain-alley-art",
      "sham-shui-po-hong-kong-bicycle-street-art",
      "central-hong-kong-hillside-market-art",
      "yau-ma-tei-hong-kong-blue-hour-alley-art",
      "positano-sunset-coast-art",
      "vintage-train-dining-car-art",
      "amalfi-terrace-cafe-art",
      "tuscan-stone-cottage-courtyard-art",
      "kyoto-autumn-storefront-art",
      "capri-sea-view-terrace-art",
      "rainy-blue-door-bookstore-art",
      "rainy-paris-corner-cafe-art",
      "bougainvillea-mediterranean-alley-art",
      "kyoto-rainy-lantern-street-art",
      "neon-rain-canal-night-art",
      "red-lantern-rainy-noodle-shop-art",
      "golden-bookshop-archway-art",
      "vintage-coastal-train-car-art",
      "amalfi-cliffside-village-art",
      "cherry-blossom-courtyard-window-art",
      "tokyo-neon-rain-crosswalk-art",
      "hong-kong-sunset-tram-street-art",
      "san-francisco-cable-car-sunset-art",
      "emerald-vintage-train-car-art",
      "lantern-market-rain-street-art",
      "lake-view-vintage-train-car-art",
      "lake-como-terrace-sunset-art",
      "red-velvet-vintage-train-car-art",
      "rainy-corner-cafe-night-art",
      "coastal-green-train-car-art",
      "old-town-green-storefront-art",
      "lake-como-waterfront-village-art",
      "lake-como-dinner-terrace-art",
      "midnight-lake-terrace-cafe-art",
      "arched-courtyard-cafe-night-art",
      "moonlit-library-window-art",
      "hong-kong-apartment-sunrise-art",
      "neon-city-rain-street-art",
      "kowloon-blue-hour-tram-street-art",
      "tuscan-hillside-villa-garden-art",
      "spanish-courtyard-fountain-night-art",
      "santorini-moonlit-stairway-art",
      "mediterranean-courtyard-fountain-art",
      "rainy-tokyo-corner-store-art",
      "greek-island-terrace-sea-view-art",
      "lake-como-flower-balcony-art",
      "moonlit-amalfi-coast-village-art",
      "amsterdam-canal-rainy-night-art",
      "moonlit-lakeside-bookshop-art",
      "vintage-dining-train-ocean-view-art",
      "venice-moonlit-canal-bridge-art",
      "blooming-cottage-doorway-art",
      "tokyo-neon-rain-avenue-art",
      "rainy-neon-corner-restaurant-art",
      "blue-rain-corner-bistro-art",
      "blue-hour-flower-shop-street-art",
      "blooming-stone-cottage-garden-art",
      "turquoise-corner-cafe-sunset-art",
      "istanbul-courtyard-mosque-sunset-art",
      "moonlit-istanbul-courtyard-art",
      "venice-balcony-canal-moonlight-art",
      "rainy-apartment-windows-night-art",
      "rainy-bicycle-cafe-corner-art",
      "green-vine-storefront-sunlit-art",
      "venice-canal-moonlit-alley-art",
      "rainy-canal-flower-cafe-night-art",
      "rainy-lantern-townhouse-art",
      "red-lantern-night-corner-shop-art",
      "rainy-red-awning-bistro-art",
      "vintage-green-train-interior-art",
      "mediterranean-balcony-sunset-cafe-art",
      "lake-como-umbrella-terrace-art",
      "seaside-bookshop-cafe-terrace-art",
      "mediterranean-fountain-courtyard-arch-art",
      "amalfi-sunset-stairway-art",
      "moonlit-coastal-village-steps-art",
      "rainy-coastal-stone-stairway-art",
      "rainy-old-town-alley-morning-art",
      "neon-rain-market-street-art",
      "rainy-stone-stairway-night-art",
      "neon-alley-rain-street-art",
      "lantern-stairway-rain-alley-art",
      "neon-tram-rain-street-art",
      "rainy-waterfront-tram-city-art",
      "snowy-mountain-village-moonlight-art",
      "rainy-green-door-noodle-shop-art",
      "spring-blossom-storefront-cafe-art",
      "riviera-flower-promenade-art",
      "seaside-tram-promenade-art",
      "sunset-bay-terrace-cafe-art",
      "moonlit-canal-rain-street-art",
      "sunlit-seaside-terrace-pergola-art",
      "greek-island-blooming-stairway-art",
      "orange-vintage-train-ocean-view-art",
      "mediterranean-flower-cottage-sea-view-art",
      "sunset-cove-lounge-terrace-art",
      "red-lantern-rain-noodle-bar-art",
      "rainy-warm-window-cafe-art",
      "tropical-beachside-cafe-terrace-art",
      "lake-como-twilight-balcony-art",
      "blue-alley-rain-lanterns-art",
      "venice-moonlit-canal-dome-art",
      "purple-awning-rain-cafe-art",
      "autumn-bookshop-storefront-art",
      "rainy-japanese-garden-teahouse-art",
      "red-lantern-rain-bar-counter-art",
      "white-pergola-sea-terrace-art",
      "aegean-blue-door-sea-patio-art",
      "sunset-balcony-easel-sea-view-art",
      "snowy-red-lantern-teahouse-art",
      "neon-rain-city-boulevard-art",
      "neon-taxi-rain-street-art",
      "neon-bus-rain-avenue-art",
      "hong-kong-sunbeam-alley-art",
      "hong-kong-rainlit-alley-glow-art",
      "hong-kong-sunlit-stairway-market-art",
      "hong-kong-rainy-arcade-alley-art",
      "hong-kong-red-awning-stair-street-art",
      "hong-kong-teahouse-alley-sunbeam-art",
      "hong-kong-crimson-awning-street-art",
      "hong-kong-blue-rain-market-alley-art",
      "hong-kong-hillside-stairway-skyline-art",
      "hong-kong-red-awning-market-lane-art",
      "hong-kong-balcony-market-street-art",
      "hong-kong-lantern-shop-alley-art",
      "hong-kong-sunlit-doorway-lane-art",
      "hong-kong-sunlit-market-cafe-art",
      "hong-kong-signboard-stair-alley-art",
      "hong-kong-rainy-market-alley-night-art",
      "hong-kong-golden-alley-signboards-art",
      "hong-kong-rooftop-alley-cityscape-art",
      "hong-kong-rainy-lantern-lane-art",
    ]);
    const shouldFilterArtTypeMedia = artTypeFilterProductHandles.has(productHandle);
    const showAllProductMedia = () => {
      mediaScope
        .querySelectorAll(
          ".product__media-item[data-media-id], [data-media-sub-id], .VIM-slide-item[data-id], .VIM-thumbnail-item[data-id]"
        )
        .forEach((mediaEl) => {
          mediaEl.hidden = false;
          mediaEl.removeAttribute("aria-hidden");
          mediaEl.classList.remove("seji-art-type-hidden");
          mediaEl.dataset.sejiArtTypeHidden = "false";
          if (mediaEl.style.getPropertyValue("display")) {
            mediaEl.style.removeProperty("display");
          }
        });

      mediaBox.querySelectorAll(".swiper").forEach((slider) => {
        if (slider.swiper) {
          slider.swiper.update();
        }
      });
    };

    if (!shouldFilterArtTypeMedia) {
      showAllProductMedia();
      return;
    }

    mediaBox.dataset.sejiArtTypeFilter = "true";

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      return;
    }

    const normalize = (value) =>
      String(value || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

    const ensureMediaFilterStyles = () => {
      if (document.getElementById("seji-art-type-media-filter-style")) return;

      const style = document.createElement("style");
      style.id = "seji-art-type-media-filter-style";
      style.textContent = `
        .seji-art-type-hidden,
        [data-seji-art-type-hidden="true"] {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    };

    ensureMediaFilterStyles();

    const artTypeControl = Array.from(
      variantPicker.querySelectorAll("[data-option-position]")
    ).find((control) => /art\s*type/i.test(control.textContent || ""));

    if (!artTypeControl) return;

    const optionPosition = Number(artTypeControl.dataset.optionPosition || 1);
    const optionKey = `option${optionPosition}`;
    const groupStarts = new Map();

    variants.forEach((variant) => {
      const optionValue = variant?.[optionKey] || variant?.options?.[optionPosition - 1];
      const mediaPosition = Number(
        variant?.featured_media?.position || variant?.featured_image?.position
      );
      const groupKey = normalize(optionValue);
      if (!groupKey || !mediaPosition) return;

      if (!groupStarts.has(groupKey) || mediaPosition < groupStarts.get(groupKey)) {
        groupStarts.set(groupKey, mediaPosition);
      }
    });

    const getSelectedArtType = () => {
      const selectedInput = artTypeControl.querySelector("input:checked");
      if (selectedInput) return normalize(selectedInput.value);

      const selectedSelect = artTypeControl.querySelector("select");
      if (selectedSelect) return normalize(selectedSelect.value);

      return "";
    };

    const getRange = (selectedArtType) => {
      const starts = Array.from(groupStarts.entries()).sort((a, b) => a[1] - b[1]);
      const selectedIndex = starts.findIndex(([key]) => key === selectedArtType);
      if (selectedIndex === -1) return null;

      return {
        start: starts[selectedIndex][1],
        end: starts[selectedIndex + 1]?.[1] || Infinity,
      };
    };

    const getMatchingMediaId = (mediaEl) =>
      mediaEl.dataset.mediaId || mediaEl.dataset.mediaSubId || mediaEl.dataset.id || "";

    const getMediaKey = (mediaEl) => {
      const mediaId = getMatchingMediaId(mediaEl);
      const idMatch = String(mediaId).match(/(\d+)(?!.*\d)/);
      return idMatch?.[1] || mediaId;
    };

    let nativeMediaMetaByKey = new Map();

    const refreshNativeMediaMeta = () => {
      nativeMediaMetaByKey = new Map();

      mediaScope
        .querySelectorAll(".product__media-item[data-media-id], [data-media-sub-id]")
        .forEach((mediaEl) => {
          if (
            mediaEl.classList.contains("VIM-slide-item") ||
            mediaEl.classList.contains("VIM-thumbnail-item")
          ) {
            return;
          }

          const mediaKey = getMediaKey(mediaEl);
          if (!mediaKey) return;

          const existingMeta = nativeMediaMetaByKey.get(mediaKey) || {};
          const img = mediaEl.querySelector("img");
          const video = mediaEl.querySelector("video");
          const position =
            Number(mediaEl.dataset.mediaPosition) || existingMeta.position || 0;
          const text = [
            existingMeta.text,
            mediaEl.dataset.mediaAlt,
            mediaEl.dataset.alt,
            img?.alt,
            img?.currentSrc,
            img?.src,
            video?.poster,
            mediaEl.getAttribute("aria-label"),
          ]
            .filter(Boolean)
            .join(" ");

          nativeMediaMetaByKey.set(mediaKey, {
            position,
            text,
          });
        });
    };

    const getMediaPosition = (mediaEl) => {
      const position = Number(mediaEl.dataset.mediaPosition);
      if (position) return position;

      const nativeMediaMeta = nativeMediaMetaByKey.get(getMediaKey(mediaEl));
      if (nativeMediaMeta?.position) return nativeMediaMeta.position;

      const mediaIndex = Number(mediaEl.dataset.index);
      return Number.isFinite(mediaIndex) ? mediaIndex + 1 : 0;
    };

    const getVimTokens = (mediaEl) =>
      String(mediaEl.dataset.alt || "")
        .replace(/^VIM_/, "")
        .split("_")
        .filter(Boolean);

    const getMediaText = (mediaEl) => {
      const nativeMediaMeta = nativeMediaMetaByKey.get(getMediaKey(mediaEl));
      const img = mediaEl.querySelector("img");
      const video = mediaEl.querySelector("video");
      return normalize(
        [
          nativeMediaMeta?.text,
          mediaEl.dataset.mediaAlt,
          mediaEl.dataset.alt,
          img?.alt,
          img?.currentSrc,
          img?.src,
          video?.poster,
          mediaEl.getAttribute("aria-label"),
        ].join(" ")
      );
    };

    const isExplicitCanvasMedia = (mediaText) => mediaText.includes("canvas");
    const isPosterPreviewMedia = (mediaText) =>
      mediaText.includes("poster-print-preview");
    const isCanvasBatchMedia = (mediaText) =>
      mediaText.includes("large-format-wall-art-preview") ||
      mediaText.includes("gallery-wall-decor-mockup") ||
      mediaText.includes("travel-art-print-product-preview") ||
      mediaText.includes("framed-wall-art-print-room-mockup");
    const isPosterMedia = (mediaText) =>
      mediaText.includes("poster") ||
      mediaText.includes("fine-art") ||
      mediaText.includes("fineart");

    const uniqueMediaElements = (mediaElements) => {
      const seenMedia = new Set();

      return mediaElements.filter((mediaEl) => {
        const mediaKey = getMediaKey(mediaEl);
        if (!mediaKey || seenMedia.has(mediaKey)) return false;

        seenMedia.add(mediaKey);
        return true;
      });
    };

    const buildMediaFilterContext = () => {
      refreshNativeMediaMeta();

      const allGalleryMedia = uniqueMediaElements(Array.from(
        mediaScope.querySelectorAll(
          ".product__media-item[data-media-id], .VIM-slide-item[data-id]"
        )
      ));
      const posterRange = getRange("poster");
      const canvasRange = getRange("canvas");
      const canvasMediaIds = new Set();
      const firstExplicitCanvasMedia = allGalleryMedia
        .filter((mediaEl) => isExplicitCanvasMedia(getMediaText(mediaEl)))
        .sort((a, b) => getMediaPosition(a) - getMediaPosition(b))[0];
      const firstCanvasPosition = firstExplicitCanvasMedia
        ? getMediaPosition(firstExplicitCanvasMedia)
        : 0;
      const baseCanvasTokens = new Set(
        firstExplicitCanvasMedia ? getVimTokens(firstExplicitCanvasMedia) : []
      );
      const laterCanvasBatchIds = new Set();

      allGalleryMedia.forEach((mediaEl) => {
        const position = getMediaPosition(mediaEl);
        const mediaText = getMediaText(mediaEl);
        const vimTokens = getVimTokens(mediaEl);
        const isCanvasMedia = isExplicitCanvasMedia(mediaText);
        const isLaterCanvasBatch =
          firstCanvasPosition &&
          position > firstCanvasPosition &&
          vimTokens.length > 0 &&
          vimTokens.every((token) => !baseCanvasTokens.has(token)) &&
          isCanvasBatchMedia(mediaText) &&
          !isPosterPreviewMedia(mediaText);
        const isCanvasRangeMedia =
          !firstCanvasPosition &&
          canvasRange &&
          position &&
          position >= canvasRange.start &&
          position < canvasRange.end;

        if (isCanvasMedia) {
          canvasMediaIds.add(getMediaKey(mediaEl));
          return;
        }

        if (isLaterCanvasBatch) {
          laterCanvasBatchIds.add(getMediaKey(mediaEl));
          return;
        }

        if (isCanvasRangeMedia) {
          canvasMediaIds.add(getMediaKey(mediaEl));
          return;
        }

      });

      if (firstExplicitCanvasMedia) {
        canvasMediaIds.add(getMediaKey(firstExplicitCanvasMedia));
      }

      laterCanvasBatchIds.forEach((mediaId) => canvasMediaIds.add(mediaId));

      return {
        posterRange,
        canvasRange,
        canvasMediaIds,
      };
    };

    const mediaBelongsToArtType = (mediaEl, selectedArtType, context) => {
      const position = getMediaPosition(mediaEl);
      const mediaText = getMediaText(mediaEl);
      const isCanvasMedia =
        context.canvasMediaIds.has(getMediaKey(mediaEl)) ||
        (!getVimTokens(mediaEl).length && isExplicitCanvasMedia(mediaText));
      const isPosterPreview = isPosterPreviewMedia(mediaText);
      const isPrintMedia = isPosterMedia(mediaText);
      const selectedRange =
        selectedArtType === "canvas" ? context.canvasRange : context.posterRange;
      const isInSelectedRange =
        selectedRange && position
          ? position >= selectedRange.start && position < selectedRange.end
          : false;

      if (selectedArtType === "canvas") {
        if (isPosterPreview) return false;
        if (isCanvasMedia) return true;
        if (context.canvasMediaIds.size) return false;
        if (selectedRange && position) return isInSelectedRange && !isPrintMedia;

        return false;
      }

      if (isCanvasMedia) return false;
      if (isPosterPreview || isPrintMedia) return true;
      if (selectedRange && position) return isInSelectedRange;

      return true;
    };

    const setActiveMedia = (mediaId) => {
      if (!mediaId) return;

      mediaScope
        .querySelectorAll("[data-media-sub-id], .VIM-thumbnail-item[data-id]")
        .forEach((thumb) => {
          thumb.classList.toggle("active", getMatchingMediaId(thumb) === mediaId);
        });

      mediaScope
        .querySelectorAll(".VIM-slide-item[data-id]")
        .forEach((slide) => {
          slide.classList.toggle("active", getMatchingMediaId(slide) === mediaId);
        });
    };

    const updateSwipers = () => {
      mediaBox.querySelectorAll(".swiper").forEach((slider) => {
        if (slider.swiper) {
          slider.swiper.update();
        }
      });
    };

    const setMediaVisibility = (mediaEl, shouldShow) => {
      // Swiper indexes slides by class, including display:none slides. Keep only
      // the selected art type in that index so Canvas starts at visible slide 0.
      if (mediaEl.classList.contains("swiper-slide") || mediaEl.dataset.sejiFilteredSlide) {
        mediaEl.dataset.sejiFilteredSlide = "true";
        mediaEl.classList.toggle("swiper-slide", shouldShow);
        if (!shouldShow) {
          mediaEl.classList.remove("swiper-slide-active", "swiper-slide-next", "swiper-slide-prev");
        }
      }
      if (mediaEl.hidden === shouldShow) {
        mediaEl.hidden = !shouldShow;
      }

      const ariaHidden = String(!shouldShow);
      if (mediaEl.getAttribute("aria-hidden") !== ariaHidden) {
        mediaEl.setAttribute("aria-hidden", ariaHidden);
      }

      mediaEl.classList.toggle("seji-art-type-hidden", !shouldShow);
      mediaEl.dataset.sejiArtTypeHidden = String(!shouldShow);

      if (shouldShow && mediaEl.style.getPropertyValue("display")) {
        mediaEl.style.removeProperty("display");
      } else if (!shouldShow && mediaEl.style.getPropertyValue("display") !== "none") {
        mediaEl.style.setProperty("display", "none", "important");
      }
    };

    let mediaFilterFrame = null;
    let previousArtType = "";
    let previousMedia = [];
    const filterEvents = new AbortController();
    const filterTimers = new Set();
    const scheduleRetry = (delay) => {
      const timer = setTimeout(() => {
        filterTimers.delete(timer);
        showMediaGroup();
      }, delay);
      filterTimers.add(timer);
    };

    const showMediaGroup = () => {
      const selectedArtType = getSelectedArtType();
      if (!selectedArtType) return;
      const mainMedia = Array.from(
        mediaScope.querySelectorAll(
          ".product__media-item[data-media-id], .VIM-slide-item[data-id]"
        )
      );
      const thumbMedia = Array.from(
        mediaScope.querySelectorAll("[data-media-sub-id], .VIM-thumbnail-item[data-id]")
      );

      const allMedia = [...mainMedia, ...thumbMedia];
      // Swiping changes slider classes/styles, but must not reset the selection.
      // Refilter only when the art type or the actual gallery nodes change.
      if (
        selectedArtType === previousArtType &&
        allMedia.length === previousMedia.length &&
        allMedia.every((mediaEl) => previousMedia.includes(mediaEl))
      ) return;
      const context = buildMediaFilterContext();
      previousArtType = selectedArtType;
      previousMedia = allMedia;

      allMedia.forEach((mediaEl) => {
        const shouldShow = mediaBelongsToArtType(mediaEl, selectedArtType, context);
        setMediaVisibility(mediaEl, shouldShow);
      });

      const firstVisibleMedia =
        mainMedia.find((mediaEl) => !mediaEl.hidden) || mainMedia[0];
      const firstVisibleMediaId = getMatchingMediaId(firstVisibleMedia);

      setActiveMedia(firstVisibleMediaId);
      updateSwipers();

      const mediaList = mediaBox.querySelector(".product__media-list");
      if (mediaList?.swiper && firstVisibleMedia) {
        const slideIndex = Array.from(
          mediaList.querySelectorAll(".swiper-slide")
        ).indexOf(firstVisibleMedia);
        if (slideIndex >= 0) {
          mediaList.swiper.slideTo(slideIndex, 0);
        }
      }

    };

    const scheduleMediaGroupUpdate = () => {
      if (mediaFilterFrame) return;

      mediaFilterFrame = requestAnimationFrame(() => {
        mediaFilterFrame = null;
        showMediaGroup();
      });
    };

    showMediaGroup();
    variantPicker.addEventListener("change", () => {
      showMediaGroup();
      scheduleRetry(80);
      scheduleRetry(250);
      scheduleRetry(600);
    }, { signal: filterEvents.signal });

    ["variant:change", "variantChange", "product:variant-change"].forEach((eventName) => {
      section.addEventListener(eventName, () => {
        showMediaGroup();
        scheduleRetry(100);
        scheduleRetry(500);
      }, { signal: filterEvents.signal });
    });

    window.addEventListener("load", showMediaGroup, { once: true, signal: filterEvents.signal });
    scheduleRetry(1000);
    scheduleRetry(2500);

    // Observe replacement/app-inserted media, not Swiper's animation styles.
    const mediaObserver = new MutationObserver(scheduleMediaGroupUpdate);
    mediaObserver.observe(mediaScope, { childList: true, subtree: true });
    mediaBox.sejiMediaFilterCleanup = () => {
      filterEvents.abort();
      mediaObserver.disconnect();
      if (mediaFilterFrame) cancelAnimationFrame(mediaFilterFrame);
      filterTimers.forEach(clearTimeout);
    };
  };

  const initStackedPreviews = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaList = section.querySelector(
      ".product__media-list[data-desktop-type='stacked_previews']"
    );
    const thumbs = section.querySelector(
      ".product__media-sublist[data-desktop-type='stacked_previews']"
    );
    if (!mediaList || !thumbs) return;

    const mediaEls = Array.from(mediaList.querySelectorAll("[data-media-id]"));
    const thumbEls = Array.from(thumbs.querySelectorAll("[data-media-sub-id]"));

    const setActiveThumb = (mediaId) => {
      thumbEls.forEach((thumb) => {
        thumb.classList.toggle("active", thumb.dataset.mediaSubId === mediaId);
      });

      const activeThumb = thumbs.querySelector(
        `[data-media-sub-id="${mediaId}"]`
      );
      if (!activeThumb) return;
      const thumbHeight = activeThumb.offsetHeight;
      const activeIndex = thumbEls.findIndex(
        (el) => el.dataset.mediaSubId === mediaId
      );

      const nextIndex = Math.min(activeIndex + 1, thumbEls.length - 1);

      const scrollTarget =
        thumbEls[nextIndex].offsetTop - thumbs.clientHeight / 2 + thumbHeight;

      thumbs.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    };

    const onScroll = () => {
      if (window.innerWidth < 990) return;
      const viewportMiddle = window.scrollY + window.innerHeight / 2;

      let closestMedia = null;
      let closestDistance = Infinity;

      for (const mediaEl of mediaEls) {
        const rect = mediaEl.getBoundingClientRect();
        const mediaTop = window.scrollY + rect.top;
        const distance = Math.abs(mediaTop - viewportMiddle);

        if (mediaTop < viewportMiddle && distance < closestDistance) {
          closestDistance = distance;
          closestMedia = mediaEl;
        }
      }

      if (closestMedia) {
        setActiveThumb(closestMedia.dataset.mediaId);
      }
    };

    requestAnimationFrame(() => {
      onScroll();
    });

    window.addEventListener("scroll", onScroll, { passive: true });

    thumbEls.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        if (window.innerWidth < 990) return;
        const mediaId = thumb.dataset.mediaSubId;
        const targetMedia = mediaList.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (targetMedia) {
          const offset =
            targetMedia.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: offset - 100, behavior: "smooth" });
          setActiveThumb(mediaId);
        }
      });
    });
  };

  const initProductAccordion = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const accordions = section.querySelectorAll(".product-accordion");

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(".product-accordion__toggle");
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("product-accordion__content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  const initStickyAddBar = (section) => {
    if (!section || !section.classList.contains("product-section")) return;

    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );
    const stickyBar = section.querySelector(".product-sticky-add-bar");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  let isZoomCursorInit = false;
  const initZoomCursor = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaWrapper = section.querySelector(".product__media-list");
    const hasZoom =
      mediaWrapper.getAttribute("data-has-desktop-zoom") === "true";
    if (!hasZoom) return;

    const cursorEl = section.querySelector(".product__media-cursor");
    if (!cursorEl) return;

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    const easingFactor = 0.2;
    let isAnimating = false;

    const animateCursor = () => {
      isAnimating = true;

      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      if (
        Math.abs(targetX - currentX) > 0.1 ||
        Math.abs(targetY - currentY) > 0.1
      ) {
        requestAnimationFrame(() => animateCursor());
      } else {
        isAnimating = false;
      }
    };

    const handleMouseMove = (e) => {
      if (!e.target.closest(".product__media-toggle")) {
        mediaWrapper.classList.remove("cursor-active");
      } else {
        mediaWrapper.classList.add("cursor-active");
      }

      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      if (!isAnimating) {
        animateCursor();
      }
    };

    const handleMouseEnter = (e) => {
      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = currentX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = currentY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      mediaWrapper.classList.add("cursor-active");
    };

    const handleMouseLeave = () => {
      mediaWrapper.classList.remove("cursor-active");
    };

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.contentRect.width >= 990 &&
          window.matchMedia("screen and (hover: hover) and (pointer: fine)")
            .matches
        ) {
          if (isZoomCursorInit) return;
          mediaWrapper.addEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.addEventListener("mousemove", handleMouseMove);
          mediaWrapper.addEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = true;
        } else {
          if (!isZoomCursorInit) return;
          mediaWrapper.removeEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.removeEventListener("mousemove", handleMouseMove);
          mediaWrapper.removeEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = false;
        }
      });
    });

    resizeObserver.observe(section);
  };

  initArtTypeMediaFilter(section);
  initSubSlider(section);
  initMainSlider(section);
  initZoomSlider(section);
  initStackedPreviews(section);

  initStickyAddBar(section);
  initZoomCursor(section);
  initProductAccordion(section);

  document.addEventListener("shopify:section:load", (event) => {
    initArtTypeMediaFilter(event.target);
    initSubSlider(event.target);
    initMainSlider(event.target);
    initZoomSlider(event.target);
    initStackedPreviews(event.target);

    initStickyAddBar(event.target);
    initZoomCursor(event.target);
    if (!window.Shopify.designMode) {
      initProductAccordion(event.target);
    }
  });
}

initProductPage(document.currentScript.parentElement);
